module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/account/security-b3d8c7832ede487b48689e53573bea8f.jpg";